export const COMPANY_SIZE_OPTIONS = [
  {
    name: '1 - 10',
    value: '1 - 10',
  },
  {
    name: '51 - 250',
    value: '51 - 250',
  },
  {
    name: '500 - 1000',
    value: '500 - 1000',
  },
  {
    name: '1,000 - 2,500',
    value: '1,000 - 2,500',
  },
  {
    name: '2,500-  5,000',
    value: '2,500-  5,000',
  },
  {
    name: '5,000 - 10,000',
    value: '5,000 - 10,000',
  },
  {
    name: '10,000 - 20,000',
    value: '10,000 - 20,000',
  },
  {
    name: '20,000 - 50,000',
    value: '20,000 - 50,000',
  },
  {
    name: '50,000 - 100,000',
    value: '50,000 - 100,000',
  },
  {
    name: '100,000 - 200,000',
    value: '100,000 - 200,000',
  },
  {
    name: '200,000 - 500,000',
    value: '200,000 - 500,000',
  },
];
export enum FilterCompanyEnum {
  ALL = 'all',
  MOST_RECENT = 'most_recent',
  MOST_REVIEWED = 'most_reviewed',
}
